// FormFrame/fields/FieldHidden.tsx
import * as React from "react"
import type { FieldDef, FormApi } from "./fieldTypes"
import { normalizeString } from "./fieldUtils"

type Props = {
    def: Extract<FieldDef, { type: "hidden" }>
    form: FormApi
}

export function FieldHidden({ def, form }: Props) {
    const r = form.register(def.name)
    return (
        <input
            type="hidden"
            name={r.name}
            value={normalizeString(r.value)}
            onChange={r.onChange}
            onBlur={r.onBlur}
            autoComplete="off"
        />
    )
}
